import React from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
import HealthAndSafetyRoundedIcon from "@mui/icons-material/HealthAndSafetyRounded";
import { motion } from "framer-motion";
import fisioLogo from "../../static/media/StrategicAllies/fisio.webp";
import fisioBanner from "../../static/media/StrategicAllies/fisiobanner.webp";

const MotionBox = motion(Box);

const treatments = [
  "Fisioterapia",
  "Terapia traumatológica",
  "Terapia neurológica",
  "Terapia deportiva",
  "Rehabilitación cardíaca",
  "Electroterapia",
  "Magnetoterapia",
  "Ultrasonido",
];

export default function FisioPartner() {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 4, md: 8 },
        px: { xs: 2, sm: 3, md: 12 },
        bgcolor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "90%" },
          maxWidth: 1300,
          mx: "auto",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: { xs: -90, md: -120 },
            left: { xs: -80, md: -110 },
            width: { xs: 220, md: 320 },
            height: { xs: 220, md: 320 },
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(229,9,20,0.10) 0%, rgba(229,9,20,0.04) 40%, rgba(229,9,20,0) 72%)",
            filter: "blur(10px)",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            right: { xs: -90, md: -120 },
            bottom: { xs: -110, md: -120 },
            width: { xs: 240, md: 350 },
            height: { xs: 240, md: 320 },
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(28,150,173,0.10) 0%, rgba(28,150,173,0.04) 42%, rgba(28,150,173,0) 72%)",
            filter: "blur(12px)",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "minmax(0,0.96fr) minmax(0,1.04fr)",
            },
            gap: { xs: 2.6, md: 3, lg: 3.6 },
            alignItems: "start",
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              order: { xs: 2, md: 1 },
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "stretch" },
            }}
          >
            <MotionBox
              initial={{ opacity: 0, x: -34 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.78, ease: [0.22, 1, 0.36, 1] }}
              sx={{
                position: "relative",
                width: { xs: "100%", sm: "82%", md: "65%", lg: "70%" },
                maxWidth: { xs: 440, sm: "none", md: "none" },
                minHeight: { xs: 300, sm: 380, md: 450 },
                borderRadius: { xs: "26px", md: "34px" },
                overflow: "hidden",
                background: "#111111",
                boxShadow: "0 26px 64px rgba(0,0,0,0.18)",
                mx: { xs: "auto", md: 0 },
              }}
            >
              <Box
                component="img"
                src={fisioBanner}
                alt="Tratamiento de rehabilitación física FisioHeart"
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.14) 28%, rgba(0,0,0,0.34) 62%, rgba(0,0,0,0.62) 100%)",
                }}
              />
            </MotionBox>

            <Box sx={{ mt: 1.8, width: "100%" }}>
              <Typography
                sx={{
                  color: "#111111",
                  fontWeight: 800,
                  fontSize: { xs: 18, md: 20 },
                  mb: 1.2,
                  letterSpacing: -0.35,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Tratamientos y servicios
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                  },
                  gap: 1,
                }}
              >
                {treatments.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      px: 1.15,
                      py: 1.05,
                      borderRadius: "18px",
                      background:
                        "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,252,253,0.96) 100%)",
                      border: "1px solid rgba(0,0,0,0.06)",
                      boxShadow: "0 10px 22px rgba(0,0,0,0.04)",
                    }}
                  >
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "13px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        color: "#ffffff",
                        background:
                          "linear-gradient(135deg,#1c96ad 0%,#0f6f80 100%)",
                        boxShadow: "0 8px 18px rgba(28,150,173,0.18)",
                      }}
                    >
                      <MedicalServicesRoundedIcon sx={{ fontSize: 18 }} />
                    </Box>

                    <Typography
                      sx={{
                        color: "#111111",
                        fontWeight: 800,
                        fontSize: 13.5,
                        lineHeight: 1.35,
                        letterSpacing: -0.12,
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              order: { xs: 1, md: 2 },
              pt: { xs: 0, md: 0.6 },
              alignItems: { xs: "center", md: "flex-start" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Box
              component="img"
              src={fisioLogo}
              alt="FisioHeart"
              sx={{
                width: "100%",
                maxWidth: { xs: 150, md: 180 },
                height: "auto",
                display: "block",
                mb: 1.8,
                mx: { xs: "auto", md: 0 },
              }}
            />

            <Box
              sx={{
                width: 74,
                height: 4,
                borderRadius: 999,
                bgcolor: "#1c96ad",
                mb: 1.6,
                mx: { xs: "auto", md: 0 },
              }}
            />

            <Typography
              sx={{
                color: "#111111",
                fontWeight: 800,
                lineHeight: 1.04,
                letterSpacing: -1,
                fontSize: {
                  xs: "clamp(28px,6vw,36px)",
                  md: "clamp(36px,3vw,50px)",
                },
                mb: 1.25,
                maxWidth: { xs: "100%", md: "20ch" },
              }}
            >
              Rehabilitación con atención humana y enfoque profesional
            </Typography>

            <Typography
              sx={{
                color: "#e50914",
                fontWeight: 800,
                fontSize: { xs: 15, md: 16 },
                lineHeight: 1.65,
                mb: 1.1,
              }}
            >
              FisioHeart brinda beneficios especiales para usuarios con membresía activa
              en NovaXFit.
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 14.8, md: 15.8 },
                color: "rgba(0,0,0,0.66)",
                fontWeight: 600,
                lineHeight: 1.76,
                mb: 2.15,
                maxWidth: { xs: "100%", md: "60ch" },
              }}
            >
              Incluye consulta totalmente gratuita y 20% de descuento en
              tratamientos de rehabilitación y terapia física.
            </Typography>

            <Box
              sx={{
                borderRadius: "24px",
                p: { xs: 1.5, md: 1.8 },
                mb: 2.15,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(249,252,253,0.98) 100%)",
                border: "1px solid rgba(0,0,0,0.06)",
                boxShadow: "0 16px 34px rgba(0,0,0,0.05)",
                maxWidth: { xs: "100%", md: 680 },
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  color: "#1c96ad",
                  fontWeight: 900,
                  fontSize: { xs: 15, md: 15.5 },
                  lineHeight: 1.45,
                  mb: 1.15,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Beneficios para la comunidad NovaXFit
              </Typography>

              <Stack spacing={1.15}>
                <Stack direction="row" spacing={1.1} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      color: "#ffffff",
                      background:
                        "linear-gradient(135deg,#1c96ad 0%,#0f6f80 100%)",
                      boxShadow: "0 8px 18px rgba(28,150,173,0.18)",
                    }}
                  >
                    <FavoriteRoundedIcon sx={{ fontSize: 20 }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: 14.7,
                        color: "#111111",
                        mb: 0.2,
                      }}
                    >
                      Consulta totalmente gratuita
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 13.9,
                        fontWeight: 650,
                        color: "rgba(0,0,0,0.66)",
                        lineHeight: 1.55,
                      }}
                    >
                      Valoración inicial sin costo.
                    </Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={1.1} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      color: "#ffffff",
                      background:
                        "linear-gradient(135deg,#1c96ad 0%,#0f6f80 100%)",
                      boxShadow: "0 8px 18px rgba(28,150,173,0.18)",
                    }}
                  >
                    <HealthAndSafetyRoundedIcon sx={{ fontSize: 20 }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: 14.7,
                        color: "#111111",
                        mb: 0.2,
                      }}
                    >
                      20% de descuento en tratamientos
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 13.9,
                        fontWeight: 650,
                        color: "rgba(0,0,0,0.66)",
                        lineHeight: 1.55,
                      }}
                    >
                      Aplica en rehabilitación y terapia física.
                    </Typography>
                  </Box>
                </Stack>
              </Stack>

              <Typography
                sx={{
                  fontWeight: 900,
                  fontSize: 15.2,
                  color: "#111111",
                  mt: 1.5,
                  mb: 1.05,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Términos y condiciones
              </Typography>

              <Stack spacing={0.95}>
                {[
                  "Aplica para usuarios con membresía activa en NovaXFit.",
                  "No aplica en tratamientos promocionales ni en promociones de temporada.",
                  "Consulta gratuita y descuento sujetos a validación previa del beneficio activo.",
                ].map((item) => (
                  <Stack
                    key={item}
                    direction="row"
                    spacing={1}
                    alignItems="flex-start"
                  >
                    <Box
                      sx={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        bgcolor: "#e50914",
                        mt: "8px",
                        flexShrink: 0,
                        boxShadow: "0 0 0 5px rgba(229,9,20,0.08)",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 14.05,
                        fontWeight: 650,
                        color: "rgba(0,0,0,0.66)",
                        lineHeight: 1.6,
                      }}
                    >
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.2}
              sx={{
                width: "100%",
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: { xs: "center", md: "flex-start" },
                flexWrap: "wrap",
              }}
            >
              <Button
                component="a"
                href="https://www.instagram.com/fisioheart.ec?igsh=cmNwMHpoY2FhNmRj"
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<InstagramIcon />}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: 360, sm: "none" },
                  mx: { xs: "auto", sm: 0 },
                  textTransform: "none",
                  fontWeight: 800,
                  borderRadius: "16px",
                  px: 3,
                  py: 1.35,
                  fontSize: 14.6,
                  color: "#ffffff",
                  background:
                    "linear-gradient(135deg,#111111 0%,#1f1f1f 46%,#e50914 100%)",
                  boxShadow: "0 16px 34px rgba(0,0,0,0.16)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg,#0b0b0b 0%,#181818 46%,#ff1a26 100%)",
                  },
                }}
              >
                Instagram
              </Button>

              <Button
                component="a"
                href="https://wa.me/593962052211?text=Hola,%20quiero%20solicitar%20más%20información%20sobre%20los%20beneficios%20de%20NovaXFit%20en%20FisioHeart"
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<LocalPhoneRoundedIcon />}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: 360, sm: "none" },
                  mx: { xs: "auto", sm: 0 },
                  textTransform: "none",
                  fontWeight: 800,
                  borderRadius: "16px",
                  px: 3,
                  py: 1.35,
                  fontSize: 14.6,
                  color: "#111111",
                  bgcolor: "#ffffff",
                  border: "1px solid rgba(28,150,173,0.22)",
                  boxShadow: "0 10px 24px rgba(0,0,0,0.04)",
                  "&:hover": {
                    bgcolor: "#f7fcfd",
                    borderColor: "rgba(28,150,173,0.38)",
                  },
                }}
              >
                0962 052 211
              </Button>

              <Button
                component="a"
                href="https://wa.me/593983555854?text=Hola,%20quiero%20solicitar%20más%20información%20sobre%20los%20beneficios%20de%20NovaXFit%20en%20FisioHeart"
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<LocalPhoneRoundedIcon />}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: 360, sm: "none" },
                  mx: { xs: "auto", sm: 0 },
                  textTransform: "none",
                  fontWeight: 800,
                  borderRadius: "16px",
                  px: 3,
                  py: 1.35,
                  fontSize: 14.6,
                  color: "#111111",
                  bgcolor: "#ffffff",
                  border: "1px solid rgba(28,150,173,0.22)",
                  boxShadow: "0 10px 24px rgba(0,0,0,0.04)",
                  "&:hover": {
                    bgcolor: "#f7fcfd",
                    borderColor: "rgba(28,150,173,0.38)",
                  },
                }}
              >
                0983 555 854
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}